























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ButtonComp extends Vue {
  @Prop() private text!: string;
  @Prop() private cssClass!: string;
  @Prop() private iconBefore!: string;
  @Prop() private iconAfter!: string;
  @Prop({ default: false }) private disabledProp!: boolean;

  clickHandler() {
    this.$emit("click", "Some data here");
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--button-primary-color": this.$store.state.globalCss.colors.buttonPrimary
        .color,
      "--button-primary-bg-color": this.$store.state.globalCss.colors
        .buttonPrimary.backgroundColor,

      "--button-secondary-color": this.$store.state.globalCss.colors
        .buttonSecondary.color,
      "--button-secondary-border-color": this.$store.state.globalCss.colors
        .buttonSecondary.borderColor,

      "--button-text-color": this.$store.state.globalCss.colors.buttonText
        .color,
      "--button-text-border-color": this.$store.state.globalCss.colors
        .buttonText.borderColor,

      "--button-product-color": this.$store.state.globalCss.colors.buttonProduct
        .color,
      "--button-product-bg-color": this.$store.state.globalCss.colors
        .buttonProduct.backgroundColor
    };
  }
}
